<div class="number-generator-container">
  <div class="content-wrapper">
    <h1 class="page-title">Client / Agreement Number Generator</h1>
    
    <div class="generator-card">
      <div class="form-row">
        <div class="prefix-selector">
          <label class="selector-label">Select Type:</label>
          <div class="button-group">
            <button 
              class="prefix-button" 
              [class.active]="prefix === 'C'"
              (click)="setPrefix('C')">
              Client Number (C)
            </button>
            <button 
              class="prefix-button" 
              [class.active]="prefix === 'A'"
              (click)="setPrefix('A')">
              Agreement Number (A)
            </button>
          </div>
        </div>

        <!-- <div class="length-selector">
          <label class="selector-label" for="numberLength">Number Length:</label>
          <input 
            type="number" 
            id="numberLength"
            class="length-input"
            [(ngModel)]="numberLength"
            min="5"
            max="10"
            placeholder="5">
        </div> -->
      </div>

      <div class="generate-section">
        <button class="generate-button flex items-center gap-2" (click)="generateNumber()" [disabled]="isGenerating">
          <i class="material-icons">autorenew</i>
          <span>{{ isGenerating ? 'Generating...' : 'Generate Number' }}</span>
        </button>
      </div>

      <div class="result-section" *ngIf="generatedNumber">
        <div class="result-display">
          <span class="result-number">{{ generatedNumber }}</span>
          <button 
            class="copy-button" 
            (click)="copyToClipboard()"
            [class.copied]="copySuccess">
            <i class="material-icons">{{ copySuccess ? 'check' : 'content_copy' }}</i>
            <span class="copy-text">{{ copySuccess ? 'Copied!' : 'Copy' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
